import { render, staticRenderFns } from "./Appointime.vue?vue&type=template&id=5d4cc32e&"
import script from "./Appointime.vue?vue&type=script&lang=js&"
export * from "./Appointime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports